
import {observable} from "mobx";
import { PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {LabelPositionEnum} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl.Options";




export class TextControlOptions extends PDFControlBaseOptions{
    Type:ControlTypeEnum.Text;
    @observable
    Text:string;
    Label:string;
    LabelPosition:LabelPositionEnum;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Label='';
        this.Text='<p>Your text goes here</p>';
        this.Type=ControlTypeEnum.Text;
        this.Styles.Width='150px';
        this.LabelPosition=LabelPositionEnum.Top;

    }
}